export default __webpack_public_path__ + "static/lozenge-dropdown-dont-1-light-6f623ed8d785488516eda5c00e91990a017d05e00f17b67c0c7f50375da133c5.png";